import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DropdownComponent implements OnChanges, OnInit {
  @Input()
  dropdownId: string;

  @Input()
  items;

  @Input()
  shouldTranslate: boolean;

  @Input()
  isDropdownOpen: boolean;

  @Output()
  manualSelectionCallback: EventEmitter<void> = new EventEmitter();

  @Output()
  isDropdownOpenChange: EventEmitter<boolean> = new EventEmitter();

  @Output()
  selectedItemChange: EventEmitter<HTMLOptionElement> = new EventEmitter();

  @ViewChild('dropdownInstance', { static: true })
  dropdownInstance: NgbDropdown;

  public disabled;
  public selectedItem;

  ngOnInit() {
    this.setDisabled();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      this.setDisabled();
      this.setSelectedItem();
    }
    if (changes.isDropdownOpen) {
      if (changes.isDropdownOpen.currentValue === true && !this.isOpen) {
        this.dropdownInstance.open();
      } else if (changes.isDropdownOpen.currentValue === false && this.isOpen) {
        this.dropdownInstance.close();
      }
    }
  }

  get isOpen(): boolean {
    return this.dropdownInstance.isOpen();
  }

  setDisabled() {
    this.disabled = !this.items || this.items.length < 2;
  }

  setSelectedItem() {
    if (this.items && this.items.length) {
      const selectedItem = this.items.find((item) => item.selected);

      if (selectedItem) {
        this.selectedItem = selectedItem;
      } else {
        this.items[0].selected = true;
        this.selectedItem = this.items[0];
      }
    } else {
      this.selectedItem = undefined;
    }

    this.selectedItemChange.emit(this.selectedItem);
  }

  changeSelectedItem(clickedItem) {
    this.items.forEach((item) => {
      item.selected = item.value === clickedItem.value;
    });

    if (this.manualSelectionCallback) {
      this.manualSelectionCallback.emit();
    }
    this.setSelectedItem();
  }

  dropdownOpenChanged(isOpened) {
    this.isDropdownOpenChange.emit(isOpened);
  }
}
